import React from 'react';
import { Table } from 'antd';
import { Settlement } from "interfaces/balances";
import { SettlementType } from '../../constants';
import { ColumnsType } from 'antd/lib/table';
import SettlementPaymentFileButton from './SettlementPaymentFileButton';
import useToastContext from 'hooks/useToastContext';


const SettlementTable = ({ settlements, payments, type, loading}: { settlements: Settlement[], payments: Map<string, string>, type: SettlementType, loading:boolean}) => {
    const IVA_VALUE = 0.21
    const DOMESTIC_CURRENCY = "ARS"
    const INTERNATIONAL_CURRENCY = "USD"
    const isInternational = type == SettlementType.INTERNATIONAL
	  const toast = useToastContext();
    const sortedItems =  settlements?.sort((a, b) => a.date.localeCompare(b.date));

    const formatValue = (value, currencyCode) => {
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: currencyCode,
      }).format(value)
    }

	const getTotalDomestic = (settlement: Settlement)=> {
		return settlement.amount_domestic + settlement.interchange_domestic + (settlement.interchange_domestic * IVA_VALUE)
	}

	const getTotalInternational = (settlement: Settlement)=> {
		return settlement.amount_international + settlement.interchange_international + settlement.isa_amount
	}
	
  const getTotal = (settlement: Settlement, type: SettlementType) =>{
		if (type == SettlementType.INTERNATIONAL) {
			return getTotalInternational(settlement);
		} else {
			return getTotalDomestic(settlement);
		}
  }

      const domesticColumns: ColumnsType<Settlement> = [
        {
          title: 'Fecha',
          dataIndex: 'date',
          key: 'date',
          sorter: (a, b) => a.date.localeCompare(b.date), // Custom sorter for date
          defaultSortOrder: 'descend'
        },
        {
          title: 'Amount',
          dataIndex: 'amount_international',
          key: 'amount_international',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.amount_domestic, DOMESTIC_CURRENCY);
          }
        },
        {
          title: 'Interchange',
          dataIndex: 'interchange_international',
          key: 'interchange_international',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.interchange_domestic, DOMESTIC_CURRENCY)
          }
        },
        {
          title: 'IVA',
          dataIndex: 'iva',
          key: 'iva',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.interchange_domestic * IVA_VALUE, DOMESTIC_CURRENCY)
          }
        },
        {
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
          render: (_value, settlement, _index) =>{
            return formatValue(getTotal(settlement, type), DOMESTIC_CURRENCY)
          }
        },
		{
			title: 'Payment',
			render: (_value, settlement, _index) => {
				const payment = payments.get(settlement.date);
				return(
          <SettlementPaymentFileButton
            settlement={settlement}
            paymentFile={payment}
            paymentType="SETTLEMENT_PAYMENT_DOMESTIC"
          />
        )
			}
		},
      ];


      const internationalColumns: ColumnsType<Settlement> = [
        {
          title: 'Fecha',
          dataIndex: 'date',
          key: 'date',
          sorter: (a, b) => a.date.localeCompare(b.date)
        },
        {
          title: 'Amount',
          dataIndex: 'amount_international',
          key: 'amount_international',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.amount_international, INTERNATIONAL_CURRENCY);
          }
        },
        {
          title: 'Interchange',
          dataIndex: 'interchange_international',
          key: 'interchange_international',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.interchange_international, INTERNATIONAL_CURRENCY)
          }
        },
        {
          title: 'Tasa ISA',
          dataIndex: 'isa_amount',
          key: 'isa_amount',
          render: (_value, settlement, _index) =>{
            return formatValue(settlement.isa_amount, INTERNATIONAL_CURRENCY)
          }
        },
        {
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
          render: (_value, settlement, _index) =>{
            return formatValue(getTotal(settlement, type), INTERNATIONAL_CURRENCY)
          }
        }
      ];


  return (
    <>
      {isInternational ? (
        <Table dataSource={sortedItems} columns={internationalColumns} loading={loading} pagination={false}/>
      ) : (
        <Table dataSource={sortedItems} columns={domesticColumns} loading={loading} pagination={false}/>
      )}
    </>
  );
}


export default SettlementTable
